/**
 * Formatos que no son de ningún dominio.
 *
 * `formatearPeso` vivía en `utils/expenses.ts` porque nació con el recibo del
 * gasto (FE-12). El día que la foto de una novedad necesitó lo mismo (FE-30),
 * importarla desde ahí habría hecho que el módulo de novedades dependiera del
 * de gastos para formatear bytes. Se movió aquí, que es lo que era.
 */

/** Tamaño de un archivo para una ficha. El tope del core son 10 MiB. */
export function formatearPeso(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
